(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["effect-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('effect-tabs')) {
    class EffectTabs extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector(':scope > [role="tablist"]');
        if (!this.list) return;
        // Tab blocks render button + panel together; move the buttons into the tablist.
        for (const tab of this.querySelectorAll(':scope > [role="tab"]')) this.list.append(tab);
        this.tabs = Array.from(this.list.querySelectorAll('[role="tab"]'));
        this.list.hidden = this.tabs.length < 2;
        if (!this.tabs.length) return;
        const open = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true' && this.panelFor(t)) || this.tabs[0];
        this.select(open);
        this.list.addEventListener('click', this.onClick);
        this.list.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      panelFor(tab) {
        return document.getElementById(tab.getAttribute('aria-controls'));
      }

      onClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab) this.select(tab);
      };

      onKeydown = (event) => {
        const i = this.tabs.indexOf(document.activeElement);
        if (i === -1) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        const step = { ArrowRight: rtl ? -1 : 1, ArrowLeft: rtl ? 1 : -1 }[event.key];
        let next = null;
        if (step) next = this.tabs[(i + step + this.tabs.length) % this.tabs.length];
        if (event.key === 'Home') next = this.tabs[0];
        if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        this.select(next);
        next.focus();
      };

      // Theme editor: selecting a tab block opens its panel
      onBlockSelect = (event) => {
        const tab = this.tabs.find((t) => this.panelFor(t) === event.target);
        if (tab) this.select(tab);
      };

      select(tab) {
        for (const t of this.tabs) {
          const on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          const panel = this.panelFor(t);
          if (panel) panel.hidden = !on;
        }
      }
    }
    customElements.define('effect-tabs', EffectTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
